import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { apiClient } from 'lib/api';
import type { MutationConfig } from 'lib/react-query';
import queryKeys from './queryKeys';
import type { CreatePinterestAdParams, CreatePinterestAdResponse } from './types';

export const createPinterestAd = async (
  body: CreatePinterestAdParams,
): Promise<CreatePinterestAdResponse> => {
  const res = await apiClient.post<CreatePinterestAdResponse>(queryKeys.createAd, body);

  if (isAxiosError(res)) {
    const error = new Error('Axios error');
    error.cause = { ...res.response?.data, status: res.response?.status };
    return Promise.reject(error);
  }

  return res.data;
};

interface UseCreatePinterestAdOptions {
  config?: MutationConfig<typeof createPinterestAd>;
}

export const useCreatePinterestAd = ({ config }: UseCreatePinterestAdOptions = {}) =>
  useMutation({ ...config, mutationFn: createPinterestAd });
